import styled, { css } from "styled-components";
import { colors2 } from "oolib";

export const StyledBlockWrapper = styled.div`
  border-radius: 0.6rem;
  overflow: hidden;
  ${({ $isSavedConfig, $isOpen }) =>
    $isSavedConfig
      ? css`
          background: transparent;
          border: 1px dashed ${colors2.grey15};
          padding: 0.6rem 0.8rem;
          [data-saved-caret] { opacity: 0; transition: opacity 0.15s ease; }
          &:hover {
            border: 1px solid ${colors2.grey20};
            [data-saved-caret] { opacity: 1; }
          }
          ${$isOpen && css`
            border: 1px solid ${colors2.grey80};
            box-shadow: 0px 4px 10px 0px #00000026;
            [data-saved-caret] { opacity: 1; }
            &:hover { border: 1px solid ${colors2.grey80}; }
          `}
        `
      : css`
          background: ${colors2.grey3};
          border: 1px solid transparent;
          padding: 1rem;

          [data-block-actions] {
            opacity: 0;
            max-width: 0;
            overflow: hidden;
            pointer-events: none;
            transition: opacity 0.15s ease, max-width 0.15s ease;
          }

          &:hover {
            background: ${colors2.white};
            border: 1px solid ${colors2.grey20};
            [data-block-actions] {
              opacity: 1;
              max-width: 4rem;
              pointer-events: auto;
            }
          }
          ${$isOpen && css`
            background: ${colors2.white};
            border: 1px solid ${colors2.grey80};
            [data-block-actions] {
              opacity: 1;
              max-width: 4rem;
              pointer-events: auto;
            }
            &:hover { background: ${colors2.white}; border: 1px solid ${colors2.grey80}; }
          `}
        `}
`;

export const StyledBlockHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 0 0.4rem;
`;

export const StyledBlockHeaderFirstRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
  grid-row: 1;
  grid-column: 1;
`;

export const StyledBlockHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
  grid-row: 1;
  grid-column: 2;
`;

export const StyledBlockHeaderFullRow = styled.div`
  grid-column: 1 / -1;
`;

export const StyledBlockSubHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
`;

export const StyledIndirectFilterHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 0.2rem;
`;


export const StyledChipsOuter = styled.div`
  margin-top: 0.8rem;
`;

export const StyledChipsInner = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
  /* overflow: hidden; */
  ${({ $expanded }) =>
    !$expanded &&
    css`
      max-height: 56px;
    `}
`;


export const StyledBlocksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.6rem ${({ $disableInlinePadding }) => $disableInlinePadding ? '0' : '1.4rem'} 0 ${({ $disableInlinePadding }) => $disableInlinePadding ? '0' : '1.4rem'};
`;

/**
 * Sits between two adjacent OR-siblings (filters that combine with OR). The
 * tighter negative margin pulls the two blocks visually closer than the default
 * 0.6rem gap, so an OR-group reads as one cluster. Centred "OR" label flanked by
 * hairlines.
 */
export const StyledOrConnector = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin: -0.2rem 0;
  padding: 0 0.2rem;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: ${colors2.grey15};
  }
`;
